export default "__VITE_ASSET__CTZgqwh2__"